import React, { FC } from 'react'
import throttle from 'lodash.throttle'
import { styled, breakpointUp } from '@moonpig/launchpad-utils'
import { ScrollToTop } from './ScrollToTop'
import { RecentlyViewedProducts } from '../RecentlyViewed/RecentlyViewedProducts'

type FixedBottomBarProps = {
  pageTitle: string
}

const StyledFixedWrapper = styled.div`
  z-index: 4;
  position: fixed;
  bottom: 0;
  width: 100%;
  margin-bottom: 0px;
  pointer-events: none;

  ${breakpointUp('md')} {
    width: 100%;
    transform: none;
  }
`

const MINIMUM_SCROLL_DEPTH = 300

export const FixedBottomBar: FC<FixedBottomBarProps> = ({ pageTitle }) => {
  const [showScrollToTop, setShowScrollToTop] = React.useState<boolean>(false)

  React.useEffect(() => {
    let prevScrollDepth = window.scrollY

    const scrollEvent = throttle(() => {
      const currentScrollDepth = window.scrollY

      setShowScrollToTop(
        currentScrollDepth > MINIMUM_SCROLL_DEPTH &&
          prevScrollDepth > currentScrollDepth,
      )

      prevScrollDepth = currentScrollDepth
    }, 100)

    window.addEventListener('scroll', scrollEvent)

    return () => window.removeEventListener('scroll', scrollEvent)
  }, [])

  return (
    <StyledFixedWrapper>
      <ScrollToTop showScrollToTop={showScrollToTop} />
      <RecentlyViewedProducts pageTitle={pageTitle} />
    </StyledFixedWrapper>
  )
}
